import { useEffect, useState } from "react";
import Confirmation from "../../components/confirmation";
import Footer from "../../components/footer";
import NavBar from "../../components/navbar";
import { useAuth } from "../../context/authprovider";
import { topicListApi } from "../../services/topic";
import { getBannedUserList, getUnbannedUserList } from "../../services/user";

export type BannedUserList = {
  id: number;
  username: string;
  givenName: string;
  lastName: string;
  email: string;
};

const UnbanUser = () => {
  const [bannedUserList, setBannedUserList] = useState<BannedUserList[]>();
  const [deleteType, setDeleteType] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedUserIndex, setSelectedUserIndex] = useState(-1)
  const { userId } = useAuth()

  useEffect(() => {
    const loadBannedList = async () => {
      const bannedList = await getBannedUserList(userId!);
      if (bannedList) {
        setBannedUserList(bannedList.data.message);
      }
    };
    loadBannedList();
  }, []);

  return (
    <>
      <NavBar />
      <div className="mt-20">
        <div className="flex flex-wrap">
          <div className="xl:mx-72 h-fit bg-white object-center shadow overflow-hidden sm:rounded-md w-5/6" >
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                  <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Username
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Full Name
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Email
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {bannedUserList &&
                    bannedUserList.map((bannedUser) => (
                      <tr key={bannedUser.id}>
                        {openModal && bannedUser.id == selectedUserIndex && (
                          <Confirmation
                            show={openModal}
                            userId={userId!}
                            id={bannedUser.id}
                            onToggle={setOpenModal}
                            selectedIndex={setSelectedUserIndex}
                            deleteType={deleteType}
                          />
                        )}
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {bannedUser.id}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {bannedUser.username}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {bannedUser.givenName + " " + bannedUser.lastName}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {bannedUser.email}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                          <button
                            className="text-indigo-600 hover:text-indigo-900"
                            type="button"
                            onClick={() => {
                              setDeleteType("unbanUser");
                              setOpenModal(true);
                              setSelectedUserIndex(bannedUser.id);
                            }}
                          >
                            Unban
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};


export default UnbanUser;
